"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ZIP_CODE_REGEXES = exports.ZIP_CODE_REGEXES = {
  USA: /^\d{5}$/,
  CAN: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
  GBR: /^[A-Za-z]{1,2}[0-9][0-9A-Za-z]?\s?[0-9][A-Za-z]{0,2}$/,
  AUS: /^\d{4}$/
};

var EMAIL_REGEX = exports.EMAIL_REGEX = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z]{2,})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;

var PAGE_QUERY_REGEX = exports.PAGE_QUERY_REGEX = /(&|\?)(page=)\d+/;